import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "maintenance-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "maintenance-page__blur" }, null, -1)
const _hoisted_3 = { class: "maintenance-page__content" }
const _hoisted_4 = { class: "maintenance-page__item" }
const _hoisted_5 = { class: "maintenance-page__item" }
const _hoisted_6 = { class: "maintenance-page__text maintenance-page__text--main" }
const _hoisted_7 = { class: "maintenance-page__text" }

import { format } from 'date-fns';
import { computed } from 'vue';

import GridLines from '@exchange/assets/grid-lines.svg';
import Logo from '@exchange/assets/one-trading-white-logo.svg';
import { capIsNativePlatform, capBrowser } from '@exchange/libs/utils/capacitor/src';
import { launchdarkly } from '@exchange/libs/utils/launchdarkly/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'MaintenancePage',
  setup(__props) {

const formatDate = (date: string | Date) => format(typeof date === 'string' ? new Date(date) : date, 'dd/MM/yy HH:mm(zzz)');

const timeFrame = launchdarkly.flags['platform-upgrade'];
const from = computed(() => formatDate(timeFrame.value.from));
const to = computed(() => formatDate(timeFrame.value.to));

const contactSupport = () => {
  const supportUrl = 'https://support.onetrading.com/requests/new';

  if (capIsNativePlatform()) {
    capBrowser.open({ url: supportUrl });
  } else {
    window.location.href = supportUrl;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(GridLines), { class: "maintenance-page__grid-lines" }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Logo), { class: "maintenance-page__logo" })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_x_modal, {
          variant: "dark",
          title: _ctx.$t('views.maintenance.dialog.title'),
          "can-close": false
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.maintenance.dialog.textMain', { start: from.value, end: to.value })), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.maintenance.dialog.textAddition')), 1)
            ])
          ]),
          buttons: _withCtx(() => [
            _createVNode(_component_x_button, {
              variant: "tertiary",
              text: _ctx.$t('views.maintenance.dialog.action'),
              onClick: contactSupport
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["title"])
      ])
    ])
  ]))
}
}

})